import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'additionalLocationDescriptionLabel',
  standalone: true
})
export class AdditionalLocationDescriptionLabelPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/podatek-lesny-il-1': {
        return 'Opis położenie lasu';
      }
      case application?.service?.url === '/podatek-lesny-dl-1': {
        return 'Opis położenie lasu'
      }
      case application?.service?.url === '/podatek-rolny-ir-1': {
        return 'Opis położenie gruntu';
      }
      case application?.service?.url === '/podatek-rolny-dr-1': {
        return 'Opis położenie gruntu';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-in-1': {
        return 'Opis położenia nieruchomości';
      }
      case application?.service?.url === '/podatek-od-nieruchomosci-dn-1': {
        return 'Opis położenia nieruchomości';
      }
      default: {
        return '';
      }
    }
  }

}
